import { useTranslation } from "react-i18next";
import MeetingCard from "../../../components/MeetingCard";
import { Event } from "src/graphql";

interface IncomingEventsSectionProps {
    events: Partial<Event>[]
}

const IncomingEventsSection: React.FC<IncomingEventsSectionProps> = ({ events }) => {
    const { t } = useTranslation();

    return (
        <section id='meetings'>
            <article>
                <h1 className='purple'>{t("incoming_meetings")}</h1>
                {events.length > 0 ? <div className='hide-scrollbar no-scrollbars overflow-x-scroll max-w-[calc(100vw-50px)] md:max-w-none'>
                    <div className='whitespace-nowrap flex flex-row md:flex-wrap '>
                        {events.map((event) => (
                            <MeetingCard key={event.id} event={event} />
                        ))
                        }
                    </div>
                </div> : <div>
                    {t("no_upcoming_events")}
                </div>}
            </article>
        </section>
    );
}

export default IncomingEventsSection